import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactsManagerComponent} from './contacts-manager.component';
import {InterventionTeamEditorModule} from "../../teams/intervention-team-editor/intervention-team-editor.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {MdProgressBarModule} from "ng-uikit-pro-standard";
import {ContactDetailsModule} from "../contact-details/contact-details.module";


@NgModule({
  declarations: [
    ContactsManagerComponent
  ],
  imports: [
    CommonModule,
    InterventionTeamEditorModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    MdProgressBarModule,
    ContactDetailsModule
  ]
})
export class ContactsManagerModule {
}
